import * as S from './Upload.styled';
import { DeleteIcon } from 'assets/icons';
import { Buttons } from 'components';

export const Content = ({
  file,
  preview,
  // app_icon,
  deleteFile,
  buttonStyle,
  buttonText,
  handleChange,
  accept,
  sizes,
}) => {
  const isPDF = (file && file.type === 'application/pdf') || preview?.endsWith('pdf');

  if (file || preview) {
    return (
      <S.Output>
        <S.ImageWrapper size={sizes.Big}>
          {isPDF ? (
            <S.PdfPreview>PDF</S.PdfPreview>
          ) : (
            <>
              {file && !preview && <img id='file' src={URL.createObjectURL(file)} alt='uploaded' />}
              {preview && <img id='preview' src={preview} alt='preview' />}
            </>
          )}
        </S.ImageWrapper>

        <S.DeleteBtn type='button' onClick={deleteFile}>
          <DeleteIcon />
        </S.DeleteBtn>
      </S.Output>
    );
  } else {
    return (
      <Buttons.SecondaryNormal customTag='label' style={buttonStyle}>
        {buttonText}
        <input type='file' onChange={handleChange} accept={accept} hidden />
      </Buttons.SecondaryNormal>
    );
  }
};
